import React from 'react';
import styled from 'styled-components';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { withQuery } from '@panel/commons/core/themev2';
import { useBreakpoint } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import loader from '@panel/commons/assets/icons/loader.gif';
import loaderUBPE from '@panel/commons/assets/icons/loader-urbania.gif';
import { site } from '@panel/commons/helpers';
import Module1 from './Module1';
import { Step1Module2 } from './Module2';
import Module4 from './Module4';
import { ProgressBox } from '../progressbox';
import { FeedbackBox } from '../feedbackbox';
import { getProgressBoxConfig } from '../progressbox/config';
import { useStepperCtx } from '../stepper';
import { SavePostingSelectors } from '../../ducks/savePosting';
import { userInfoSelectors } from '../../../../panel/src/state/ducks/user';

const loaderLogo = site.id !== 'UBPE' ? loader : loaderUBPE;

const DisabledOverlay = styled.div`
  position: fixed;
  display: block;
  z-index: 999;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(256, 256, 256, 0.6);
  border-radius: 8px;
  background-image: url(${loaderLogo});
  background-repeat: no-repeat;
  background-size: 100px;
  background-position: center;
`;

const Container = styled.div`
  display: block;
  width: 100%;
  padding: ${props => (!props.savedFromModal ? '0px 67px' : '0px')};
  margin-top: 40px;
  white-space: normal;
  min-height: 692px;
  ${withQuery.md.down()} {
    padding: 0px 30px;
    margin-top: 0px;
    min-height: auto;
  }
  ${withQuery.sm.down()} {
    padding: 0px 30px;
    margin-top: 0px;
  }
  ${withQuery.xs.down()} {
    padding: 0px;
    margin-top: 0px;
  }
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1440px;
  margin: 0px auto;
  white-space: normal;
  ${withQuery.lg.down()} {
    width: auto;
  }
  ${withQuery.sm.down()} {
    margin: 0px auto;
  }
`;

const Aside = styled.div`
  flex: 0 1 20%;
`;

const ModuleContainer = styled.div`
  flex: 0 1 75%;
  max-width: 75%;
  margin: 0px auto;
  ${withQuery.lg.down()} {
    max-width: 100%;
    padding: 0px 0px 0px 110px;
  }
  ${withQuery.md.down()} {
    padding: 0px;
    margin: 0px;
    flex: none;
  }
  ${withQuery.xxs.down()} {
    padding: 0px;
    -webkit-flex: none;
    flex: none;
  }
`;

function Step1Container() {
  const user = useSelector(userInfoSelectors.getuserInfoState);
  const { savedFromModal } = useSelector(SavePostingSelectors.getSavePostingState);
  const { currentStep } = useStepperCtx();
  const [reachedBreakPoint] = useBreakpoint(1280);
  const { t } = useTranslation();
  const params = useLocation().search;
  const modules = getProgressBoxConfig(currentStep);
  const { name } = user;

  return (
    <Container savedFromModal={savedFromModal}>
      {savedFromModal && <DisabledOverlay />}
      <Wrapper>
        {modules && reachedBreakPoint && (
          <Aside>
            <ProgressBox modules={modules} />
            <FeedbackBox />
          </Aside>
        )}
        <Switch>
          <Route path='/publicador/principales' exact>
            <Redirect to={{ pathname: '/publicador/principales/operacionypropiedad', search: params }} />
          </Route>
          <Route path='/publicador/principales/operacionypropiedad'>
            <ModuleContainer>
              <Module1
                title={name ? t('publisher.step1.mainTitle', { value: ` ${name}` }) : t('publisher.step1.mainTitle')}
              />
            </ModuleContainer>
          </Route>
          <Route path='/publicador/principales/ubicacion'>
            <ModuleContainer>
              <Step1Module2
                back='operacionypropiedad'
                step='principales'
                title={name ? t('publisher.step1.mainTitle', { value: ` ${name}` }) : t('publisher.step1.mainTitle')}
                eventName='Principales Modulo2'
              />
            </ModuleContainer>
          </Route>
          <Route path='/publicador/principales/caracteristicas'>
            <ModuleContainer>
              <Module4
                back='ubicacion'
                step='principales'
                title={name ? t('publisher.step1.mainTitle', { value: ` ${name}` }) : t('publisher.step1.mainTitle')}
                eventName='Principales Modulo3'
              />
            </ModuleContainer>
          </Route>
        </Switch>
      </Wrapper>
    </Container>
  );
}

export default Step1Container;
